/**
 * RESPONSIBILITY: close the Visit page with a way to get in touch.
 *
 * The deep band the House of Honor page ends on, so a page that ends in a question for
 * the church ends the same way everywhere.
 */
import type { VisitCtaSection } from '@app/sections';
import { Page, hrefFor } from '../commons/pages';

export function VisitCta({ c }: { c: VisitCtaSection }) {
  if (!c.heading && !c.body && !c.ctaLabel) return null;

  return (
    <section className="band band-deep band-centre">
      <div className="wrap">
        {c.heading && <h2>{c.heading}</h2>}
        {c.body && <p className="lede">{c.body}</p>}
        {c.ctaLabel && (
          <div className="btns btns-centre">
            <a className="btn btn-light" href={c.ctaHref || hrefFor(Page.Contact)}>{c.ctaLabel}</a>
          </div>
        )}
      </div>
    </section>
  );
}
